import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from '../general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-verify-payment',
  templateUrl: './verify-payment.component.html',
  styleUrls: ['./verify-payment.component.css']
})
export class VerifyPaymentComponent implements OnInit{
  constructor(
    private route:ActivatedRoute, 
    private toaster: ToastrService,
    private s:GeneralService,
    private r:Router
    ){}
  ngOnInit(): void {
    let ref = ''
    let gateway = ''

     if(this.route.snapshot.queryParams['reference']){
       ref = this.route.snapshot.queryParams['reference']
       gateway = 'paystack'
       
    }else{
       ref = this.route.snapshot.queryParams['transaction_id']
       gateway = 'flutterwave'
    }
    this.confirmPayment(ref,gateway);

  }

confirmPayment(reference:string,gateway:string ) {
    this.s.confirmPayment(reference, gateway)
      .subscribe((r: { [key: string]: any }) => {
        this.s.loader = false;
        if (r['message'] == 'Payment successfully' && r['errors'].length == 0) {
          this.toaster.success(
            "successfully purchased policy."
          );
          localStorage.setItem('user',JSON.stringify(r['user'])) 
          this.r.navigateByUrl('main/policy-details/'+r['PolicyDetail']['_id']);
        } 
        else if (r['message'] == 'Payment successfully' && r['errors'].length > 0) {
         for (let index = 0; index < r['errors'].length; index++) {
          //  r['errors'][index]
           this.toaster.error(r['errors'][index]['success'].toString());
           this.toaster.error(r['errors'][index]['errors']);
           this.toaster.error(r['errors'][index]['error']);
         }
          this.toaster.info(
            "Some certificate were not processed. Call customer service for assistance"
          );
          localStorage.setItem('user',JSON.stringify(r['user'])) 
          this.r.navigateByUrl('main/policy-details/'+r['PolicyDetail']['_id']);
        }

      });
  }


}
